import { isEmpty, omit, each } from 'lodash';

import {
    SET_FLASHING_TICKET_PARTNER_ID,
    REQUEST_FORM_SUBMIT_FLASHING_TICKET,
    SUCCESS_FORM_SUBMIT_FLASHING_TICKET,
    FAILURE_FORM_SUBMIT_FLASHING_TICKET
} from './constants';

import { makeActionCreator } from '../../utils/actionsUtils';

import { CALL_API } from '../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const setPartnerId = makeActionCreator(SET_FLASHING_TICKET_PARTNER_ID, 'id');

export function sendFlashingTicket(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }

    // Convert request to form-data request that contains FILES + JSON BODY
    let files = formData.file;
    let dataset = omit(formData, 'file');

    let form = new FormData();
    each(files, file => form.append('file', file));
    const extension = files[0].name.substring(files[0].name.lastIndexOf('.')).replace('.', '');

    const body = { ...dataset, extension: extension };

    form.append('body', new Blob([JSON.stringify(body)], { type: 'application/json' }));

    return {
        [CALL_API]: {
            endpoint: '/flashing-ticket',
            types: [
                REQUEST_FORM_SUBMIT_FLASHING_TICKET,
                SUCCESS_FORM_SUBMIT_FLASHING_TICKET,
                FAILURE_FORM_SUBMIT_FLASHING_TICKET
            ],
            body: form,
            successCallback: (response, dispatch) => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/flashing-ticket/actions.js